// Тонкий fetch-фасад: credentials:'include' - всегда, чтобы cookie httpOnly уходили с запросом.
// 401 из /api/staff/* - глобальный сигнал "нужен логин", ловим в QueryClient defaultOptions.

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly body?: unknown,
  ) {
    super(message);
  }
}

export interface ApiOptions extends RequestInit {
  json?: unknown;
}

export async function api<T = unknown>(path: string, opts: ApiOptions = {}): Promise<T> {
  const { json, headers, ...init } = opts;
  const res = await fetch(path, {
    credentials: 'same-origin',
    ...init,
    headers: {
      ...(json !== undefined ? { 'Content-Type': 'application/json' } : {}),
      ...headers,
    },
    body: json !== undefined ? JSON.stringify(json) : (init.body ?? undefined),
  });
  if (!res.ok) {
    let body: unknown = null;
    try {
      body = await res.json();
    } catch {
      /* ignore */
    }
    const msg = extractMessage(body) ?? `${res.status} ${res.statusText}`;
    throw new ApiError(msg, res.status, body);
  }
  // 204 No Content
  if (res.status === 204) return undefined as T;
  const contentType = res.headers.get('content-type') ?? '';
  if (contentType.includes('application/json')) return (await res.json()) as T;
  return (await res.text()) as unknown as T;
}

function extractMessage(body: unknown): string | null {
  if (!body || typeof body !== 'object') return null;
  const m = (body as { message?: unknown }).message;
  if (typeof m === 'string') return m;
  if (Array.isArray(m) && typeof m[0] === 'string') return m[0];
  return null;
}
